export const init = () => {
  initEvents();
};

// Init handlers and componants of the cartridge
const initEvents = () => {
  // Init small sliders with slick
  window.decathlon.tools.slickReinitSlider('.product-item', '.product-img', '', window.productListSlickSettings);

  // Init custom select
  $('.selectpicker').selectpicker('refresh');

  // Filter with select
  if (cube.$id('order-filter')) cube.$id('order-filter').on('change', reloadPurchase);

  // Paginate with buttons
  const paginationButtons = cube.$$('.change-page, .next, .previous');
  if (paginationButtons.length) paginationButtons.forEach(item => item.on('click', reloadPurchase));

  const makeReturnButtons = cube.$$('.make-return-button');
  if (makeReturnButtons.length) makeReturnButtons.forEach(item => item.on('click', makeReturn));

  const makeReturnPopupButtons = cube.$$('.make-return-popup-button');
  if (makeReturnPopupButtons.length) makeReturnPopupButtons.forEach(item => item.on('click', updateReturnCta));
};

// Change the orderId of the CTA in the return modal
const updateReturnCta = e => {
  e.preventDefault();
  if (cube.$id('makeReturnButton'))
    cube.$id('makeReturnButton').setAttribute('data-order-id', e.target.dataset.orderId);
};

// Make a return
const makeReturn = e => {
  e.preventDefault();
  window.throwEvent(window.Events.CREATE_RETURN, e.target.dataset.orderId);
};

// Reload cartridge when filtering or paginating
const reloadPurchase = e => {
  e.preventDefault();

  const url = window.location.href.split(/[?#]/)[0];
  const query = window.location.href.split(/[?#]/)[1];

  const filter = cube.$id('order-filter') && cube.$id('order-filter').value;
  const currentPage = e.target.closest('[data-page]') ? e.target.closest('[data-page]').dataset.page : 1;

  const newQuery = `filter=${filter}&currentPage=${currentPage}`;
  const params = { filter, currentPage };

  if (query === newQuery) return;

  window.history.pushState({}, null, `${url}?${newQuery}`);

  window.reloadCartridgeContentCollection(e.target, 'my-purchase', params, reloadPurchaseSuccess);
};

const reloadPurchaseSuccess = () => {
  initEvents();
  cube.ui.smoothScroll(0);
};



// WEBPACK FOOTER //
// ./src/customer/account/account-purchases.js